import { EntityReport } from "../../entity/EntityReport";

export class DtoReportsDeleteRes extends EntityReport {
  public message: string | null = null;
}
